import { render, staticRenderFns } from "./SavePassenger.vue?vue&type=template&id=ddc8518a&scoped=true"
import script from "./SavePassenger.vue?vue&type=script&lang=js"
export * from "./SavePassenger.vue?vue&type=script&lang=js"
import style0 from "./SavePassenger.vue?vue&type=style&index=0&id=ddc8518a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8518a",
  null
  
)

export default component.exports